// apps/dashboard/src/stores/density.store.ts
// UI density preference — persisted to localStorage.

import type { Density } from '@ominiflow/ui';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DensityState {
  density: Density;
  setDensity: (d: Density) => void;
  cycle: () => void;
}

const ORDER: Density[] = ['compact', 'comfortable', 'spacious'];

export const useDensityStore = create<DensityState>()(
  persist(
    (set, get) => ({
      density: 'comfortable',
      setDensity: (density) => set({ density }),
      cycle: () => {
        const current = get().density;
        const idx = ORDER.indexOf(current);
        set({ density: ORDER[(idx + 1) % ORDER.length] });
      },
    }),
    { name: 'omniflow-density' },
  ),
);
